import { customMedia } from '@space-lib/styles'
import styled from 'styled-components'

export const ListContainer = styled.div<{
  isViewAsEnabled: boolean
}>`
  overflow-y: auto;
  height: ${({ isViewAsEnabled }) =>
    isViewAsEnabled ? 'calc(100dvh - 12.3rem)' : 'calc(100dvh - 7.175rem)'};

  ${customMedia.greaterThan('lg')`
    height: calc(100dvh - 22rem);
  `}
`
